<mat-progress-bar mode="indeterminate" *ngIf="buffer"></mat-progress-bar>
<h2 mat-dialog-title class="p-6">Update Phone Number</h2>

<mat-dialog-content>
    <form [formGroup]="phoneForm">
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="Enter your phone number" mask="(000) 000-0000" />
            <mat-error *ngIf="phoneForm.get('phoneNumber')?.hasError('required')">
                Phone number is required.
            </mat-error>
            <mat-error *ngIf="phoneForm.get('phoneNumber')?.hasError('pattern')">
                Please enter a valid phone number.
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-6">
    <button mat-raised-button color="primary" [disabled]="!phoneForm.valid" (click)="onUpdate()">Update</button>
</mat-dialog-actions>